import {Annotation} from './Annotation'

/**
 * Metadata for the component event property for the form builder.
 */
export class EventAnnotation extends Annotation {
}
